<div id="wrap" [@casePracticeTeamMainIntroAnimation] (click)="screenClick()" *ngIf="decisionTree">
    <div id="reviewBtn" class="fontSize16" (click)="reviewConversation($event)">
        场景回顾
    </div>

    <img src="{{assetsRoute}}/picture/casepracticeteam/all.png" alt="" id="allPeople" class="casePracticeTeamMain peoplePic">
    <img src="{{assetsRoute}}/picture/casepracticeteam/f1.png" alt="" id="redPeople" class="peoplePic">
    <img src="{{assetsRoute}}/picture/casepracticeteam/f2.png" alt="" id="bluePeople" class="peoplePic">
    <img src="{{assetsRoute}}/picture/casepracticeteam/f3.png" alt="" id="purplePeople" class="peoplePic">
    <img src="{{assetsRoute}}/picture/casepracticeteam/f4.png" alt=""  id="blackPeople" class="peoplePic">
    <img src="{{assetsRoute}}/picture/casepracticeteam/notice.png" alt="" id="notice" class="casePracticeTeamMain peoplePic" *ngIf="guideStatus">

    <!-- 多人角色 -->
    <div id="multiPeople">
      <div class="multiPeopleBlock">
        <img src="{{assetsRoute}}/picture/casepracticeteam/f1.png" alt="" id="redPeopleMulti" class="peoplePic">
      </div>
      <div class="multiPeopleBlock">
        <img src="{{assetsRoute}}/picture/casepracticeteam/f2.png" alt="" id="bluePeopleMulti"  class="peoplePic">
      </div>
      <div class="multiPeopleBlock">
        <img src="{{assetsRoute}}/picture/casepracticeteam/f3.png" alt="" id="purplePeopleMulti" class="peoplePic">
      </div>
      <div class="multiPeopleBlock">
        <img src="{{assetsRoute}}/picture/casepracticeteam/f4.png" alt=""  id="blackPeopleMulti" class="peoplePic">
      </div>
    </div>

    <div id="nextStep" class="fontSize18" *ngIf="guideStatus">
        点击屏幕任意处继续
    </div>

    <div id="nameBoxWrap">
      <div id="nameBox" class="fontSize16">
          <div id="nameBoxInner">
            {{currentRole}}
          </div>
      </div>
    </div>

    <div id="chatBox" class="fontSize16">
        <div id="chatBoxInner">
        </div>
    </div>

      <img [@chatBoxTeacherAnimation]="chatBoxTeacherShow ? 'showTeacher' : 'hideTeacher'" src="{{assetsRoute}}/picture/casepracticeteam/teacher.png" alt="" id="teacherPic">
      <div [@chatBoxTeacherAnimation]="chatBoxTeacherShow ? 'showTeacher' : 'hideTeacher'" id="nameBoxTeacher" class="fontSize16">
        <div id="nameBoxTeacherInner">
          导师点评
        </div>
      </div>
      <div [@chatBoxTeacherAnimation]="chatBoxTeacherShow ? 'showTeacher' : 'hideTeacher'" id="chatBoxTeacher" class="fontSize16">
          <div [@chatBoxTeacherAnimation]="chatBoxTeacherShow ? 'showTeacher' : 'hideTeacher'" id="chatBoxTeacherInner">
          </div>
      </div>

    <div id="voiceOver" class="fontSize16">
        <div id="voiceOverInner" class="textVerticalCenter">
        </div>
    </div>

    <div id="tipBox" [@tipBoxAnimation]="tipBoxShow ? 'showTipBox' : 'hideTipBox'" class="fontSize18">
        <span>
            恭喜你，已经解决了一个出了问题的因素。<br/><br/>
            接下来你想解决哪个问题因素呢？
        </span>
        <div id="tipBoxBtn" (click)='goBack()'>
            返回列表
        </div>
    </div>


    <div id="optionWrap" [@optionWrapAnimation]="optionWrapShow ? 'showOptionWrap': 'hideOptionWrap'">

      <div *ngIf="!type">
        <div class="option fontSize16" *ngFor="let option of currentNode.option;let i = index" id="option{{i}}" (touchstart)="onOptionMouseDown(i, $event)"  (touchend)="onOptionMouseUp($event)">
          {{option.multi_option_comment}}
          <div class="loading"><div class='dotting' id='dotting1'></div><div class='dotting' id='dotting2'></div><div class='dotting' id='dotting3'></div></div>
          <div class="pressing"><div class="pressingOption">{{option.multi_option_comment}}</div></div>
        </div>
      </div>

      <div *ngIf="type">
        <div class="option fontSize16" *ngFor="let option of currentNode.option;let i = index" id="option{{i}}" (mousedown)="onOptionMouseDown(i, $event)" (mouseup)="onOptionMouseUp($event)">
          {{option.multi_option_comment}}
          <div class="loading"><div class='dotting' id='dotting1'></div><div class='dotting' id='dotting2'></div><div class='dotting' id='dotting3'></div></div>
          <div class="pressing"><div class="pressingOption">{{option.multi_option_comment}}</div></div>
        </div>
      </div>

    </div>
    <div id="shade"></div>

    <div id="reviewBox" [@reviewBoxAnimation]="reviewBoxShow ? 'showReviewBox' : 'hideReviewBox'">
      <p class="excellentDemonstrationTitle flowerBorderBottom">场景回顾</p>
        <!--<div id="reviewBoxTitle" class="fontSize18 lineHeight24">-->
            <!--场景回顾-->
        <!--</div>-->

        <div *ngFor="let item of conversationHistory;let i = index">
            <div class="reviewItem" *ngIf="item.role!='我的选择'">
                <div class="reviewRole fontSize14 lineHeight24"  *ngIf="item.role!='王立娜&方科科' && item.role!='导师点评' && item.role!='方科科&王立娜&季宁'"
                     [ngClass]="{'roleColor1':item.role=='方科科','roleColor2':item.role=='王立娜','roleColor3':item.role=='季宁','roleColor4':item.role=='秦飞','roleColor5':item.role=='我','roleColor6':item.role=='旁白'}">
                    {{item.role}}
                </div>
                <div  class="reviewRole fontSize14 lineHeight24" *ngIf="item.role=='王立娜&方科科'" [ngClass] ="{'roleColor7':item.role=='王立娜&方科科'}">王&方</div>
                <div  class="reviewRole fontSize14 lineHeight24" *ngIf="item.role=='方科科&王立娜&季宁'" [ngClass] ="{'roleColor8':item.role=='方科科&王立娜&季宁'}">季宁等</div>
                <div class="reviewComment fontSize14 lineHeight21"  *ngIf="item.role!='导师点评'">
                    {{item.comment}}
                </div>

                <div class="bg-lightBlue" *ngIf="item.role == '导师点评'">
                  <div class="reviewRole fontSize14 lineHeight24 excellentDemonstrationTitle" >
                    {{item.role}}
                  </div>
                  <div class="reviewComment2 fontSize14 lineHeight21">
                    {{item.comment}}
                  </div>
                </div>
            </div>
            <div class="myChoiceItem  fontSize14" *ngIf="item.role=='我的选择'">
                <div class="myChoiceHead">
                    我的选择
                </div>
                <div class="myChoiceComment lineHeight21">
                    {{item.comment}}
                </div>
            </div>
        </div>

    </div>

    <div id="closeBtn" (click)="closeTip($event)"></div>
</div>

<div id="shade2">
  <img src="{{assetsRoute}}/picture/casepracticeteam/img1.png" alt="" id="pressTipPic1">
  <div id="pressTipText" class="fontSize24">长按按钮进行选择</div>
  <div id="pressTipButton" class="fontSize18" (click)="pressTipOut()">朕知道了</div>
</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-team-main/case-practice-team-main.component.html